module.exports = __webpack_public_path__ + "static/media/11NEPAD3.8c776f0e.jpg";